import React from 'react'
import Image from '@components/Image'
import ModalBottom from '@components/ModalBottom'
import isServerSide from '@helpers/misc/isServerSide'
import useOrderGroup from '@hooks/useOrderGroup'
import useSessionStorageState from '@hooks/useSessionStorageState'
import {useRouter} from 'next/router'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

function cleanSessionLocalStore() {
  if (isServerSide()) return
  sessionStorage.removeItem('onTable')
  sessionStorage.removeItem('orderGroupId')
  sessionStorage.removeItem('onTableModal')
}

export default function OnTableModal() {
  const [open, setOpen] = useSessionStorageState('onTableModal', true)
  const [orderGroupId] = useSessionStorageState('orderGroupId')
  const [onTable] = useSessionStorageState('onTable')
  const orderGroup = useOrderGroup(orderGroupId)
  const router = useRouter()
  const {t} = useTranslation('website', {keyPrefix: 'order.cart.welcomeModal'})

  if (onTable && orderGroup && orderGroup.status === 'closed') {
    cleanSessionLocalStore()
    router.push(`/checkout-on-table/success`)
  }

  if (!onTable || !open) return null

  return (
    <ModalBottom close={() => setOpen(false)}>
      <div className={styles.container}>
        <Image
          src="/images/onTable/peopleEating.png"
          className={styles.image}
          alt="Personas"
          height={200}
          width={200}
        />
        <div className={styles.containerTitle}>
          <h1>{t('welcome')}</h1>
          <p>{t('orderToTable')}</p>
        </div>
        <p className={styles.containerTitle}>{t('how')}</p>
        <div className={styles.containerText}>
          <div>{t('registerEmail')}</div>
          <div>{t('addProducts')}</div>
          <div>{t('confirmOrder')}</div>
        </div>
        <p className={styles.containerTitle}>{t('orderDirectly')}</p>
        <div className={styles.containerText2}>
          <div>{t('weAreWaiting')}</div>
        </div>
      </div>
    </ModalBottom>
  )
}
